import { formatDate } from '../../../utils/formatDate';
import { audiencerateApi } from '../../audiencerate';
import { TableResponse } from '../types';
import { GetUnifiedProfileArgs, GetUnifiedProfileCountArg, GetUnifiedProfilesArgs, UnifiedProfileListResponse, UnifiedProfileResponse } from './types';

const unifiedProfilesApi = audiencerateApi.injectEndpoints({
  endpoints: (build) => ({
    getUnifiedProfiles: build.query<TableResponse<UnifiedProfileListResponse>, GetUnifiedProfilesArgs>({
      query: ({ workspaceId, limit, offset, searchText: search }) => ({
        url: `/v1/workspaces/${workspaceId}/unified-profile`,
        params: { limit, offset, search },
      }),
      transformErrorResponse: (baseQueryReturnValue) => {
        if (baseQueryReturnValue.status === 500) {
          return [];
        }

        return baseQueryReturnValue;
      },
      providesTags: ['UnifiedProfiles'],
    }),
    getUnifiedProfile: build.query<UnifiedProfileResponse, GetUnifiedProfileArgs>({
      query: ({ workspaceId, unifiedProfileId }) => ({
        url: `/v1/workspaces/${workspaceId}/unified-profile/${unifiedProfileId}`,
      }),
      transformResponse: (response: UnifiedProfileResponse) => ({
        ...response,
        profileCreatedAt: formatDate(response.profileCreatedAt),
        profileUpdatedAt: formatDate(response.profileUpdatedAt),
      }),
      providesTags: ['UnifiedProfile'],
    }),
    getUnifiedProfileCount: build.query<number, GetUnifiedProfileCountArg>({
      query: ({ workspaceId, searchText: q }) => ({
        url: `/v1/workspaces/${workspaceId}/unified-profile/count`,
        params: { search: q },
      }),
      providesTags: ['UnifiedProfilesCount'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetUnifiedProfileQuery, useLazyGetUnifiedProfilesQuery, useGetUnifiedProfileCountQuery, useLazyGetUnifiedProfileCountQuery } =
  unifiedProfilesApi;
